<template>

    <div>

        <section class="pb">
          <el-row class="pb">

            <good-table
             :cols="cols"
             :rows="rows"
             :per-page="5"
             theme="nocturnal"
            />

      </el-row>

      <el-row>
            <el-col :span="24" style="min-height: 50em; max-height: 100em;">
              <full-calendar
              :options="calendarOptions"
              />
            </el-col>
          </el-row>

    </section>


    <el-dialog title="Event" :visible.sync="showDialog">
      <el-form :inline="!isDesktop" :label-position="isDesktop ? 'left' : 'top'" :label-width="isDesktop ? '120px' : null">

        <el-form-item :class="event.className" label="Item"><b>{{event.item}}</b></el-form-item>

        <el-row type="flex" justify="start" :gutter="16">
          <el-col>
            <el-form-item label="Category"><b>{{event.category}}</b></el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="Sub-Category"><b>{{event.subCategory}}</b></el-form-item>
          </el-col>

        </el-row>

        <el-row type="flex" justify="start" :gutter="16">

          <el-col>
            <el-form-item label="Days"><b>{{event.days}}</b></el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="Date"><b>{{formatDate(event.itemDate)}}</b></el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <site-card v-if="site" :site-data="site" />

    </el-dialog>

  </div>
</template>

<script>

import axios from '@/lib/axiosClient'

import SiteCard from '@/components/sites/SiteCard'

import FullCalendar from '@fullcalendar/vue'

import daygrid from '@fullcalendar/daygrid'
import timegrid from '@fullcalendar/timegrid'
import listgrid from '@fullcalendar/list'

import interactionPlugin from '@fullcalendar/interaction'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  name: 'events-calendar',

  mixins: [DateMixins, NumberMixins],

  components: {
    FullCalendar,
    SiteCard
  },


  props: {

    category: {
      type: String,
      default: null
    },

    subCat: {
      type: String,
      default: null
    },

    view: {
      type: String,
      default: 'month'
    },

    events: {
      type: Array,
      default: function () {
        return []
      }
    }

  },

  computed: {
    url: function () {
      var ep = '/calendar/' +
      this.start + '/' + this.end + (this.category
        ? '/' + this.category
        : this.subCat ? '/' + this.subCat : '') +
        '?orgCategory=' + this.org().category +
        '&orgId=' + this.org().id

      return ep
    }

  },


  watch: {

    events: function (ev) {

      if (this.isArray(ev)) {
        this.calEvents = ev
        this.rows = this.calEvents.data
      }

    }

  },



  methods: {


    format (date) {
      return this.formatDate(date)
    },


    formatDays (num) {
      return this.formatNumber(num, 0)
    },



    showEvent (event) {
      this.event = event.event.extendedProps.data

      if (this.isNumber(this.event.longitude) && this.isNumber(this.event.latitude)) {
        this.site = {siteName: this.event.siteName, siteId: this.event.siteId, longitude: this.event.longitude, latitude: this.event.latitude}
      } else {
        this.site = null
      }

      this.showDialog = true
    },


    getCalendar (info = null, callback, failCallback = null) {

      if (info) {
        this.start = this.formatDateSql(info.start)
        this.end = this.formatDateSql(info.end)
      } else {
        return null
      }

      axios.get(this.getEndpoint(this.url)).then(response => {
        this.calEvents = []
        this.rows = []
        this.rows = response.data

        for (let item in response.data) {

          if (response.data[item]) {

            let thing = {
              title: response.data[item].siteId && response.data[item].item
                ? response.data[item].siteId + ' - ' + response.data[item].item
                : response.data[item].item ? response.data[item].item : response.data[item].category,
              start: response.data[item].itemDate ? response.data[item].itemDate : null,
              end: response.data[item].itemDate ? response.data[item].itemDate : null,
              className: response.data[item].category
              ? [response.data[item].category === 'Actions'
                ? 'event-' + response.data[item].category.toLowerCase() + '-' + response.data[item].subCategory.toLowerCase()
                : 'event-' + response.data[item].category.toLowerCase()]
              : null,
              data: response.data[item]
            }
            this.calEvents.push(thing)

          } // if

        } // for

        callback(this.calEvents)

        return this.calEvents
      })
      .catch(e => {
        console.error('X. Calendar error=', e)
        failCallback(e)
      })
    }
  },


  data () {

    return {
      event: {},
      site: null,
      showDialog: false,
      start: new Date(),
      end: new Date(),
      calEvents: [],
      calendarOptions: {
        plugins: [daygrid, timegrid, listgrid, interactionPlugin],
        firstDay: 1,
        initialView: 'dayGridMonth',
        eventClick: this.showEvent,
        events: this.getCalendar,
        headerToolbar: {
          left: 'prevYear,prev,next,nextYear today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek,dayGridDay,list'
        },
        dayMaxEvents: true
      },
      title: 'Dashboard',
      cols: [
            {
              label: 'Date',
              field: 'itemDate',
              formatFn: this.format
            },
            {
              label: 'Item',
              field: 'item',
            },
            {
              label: 'Site Name',
              field: 'siteName'
            },
            {
              label: 'Category',
              field: 'category',
              tdClass: 'hidden-sm-and-down',
              thClass: 'hidden-sm-and-down'
            },
            {
              label: 'Sub-Category',
              field: 'subCategory',
              tdClass: 'hidden-sm-and-down',
              thClass: 'hidden-sm-and-down'
            },
            {
              label: 'Days',
              field: 'days',
              html: true,
              formatFn: this.formatDays
            },
          ],
      rows: [],
    }

  },


  created () {

    if (!this.events || this.events.length === 0) {
      this.getCalendar()
    }

  }

}
</script>

<style scoped>
 .pb {padding-bottom: 0.528em;}
</style>



// WEBPACK FOOTER //
// EventsCalendar.vue?05c2ca22